function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  fill: "#C4C4C4",
  stroke: "#04223B",
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_6498_206)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.33301 4.88892H4.44412H13.333",
  stroke: "#04223B",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.111 4.88885V3.77774C6.111 3.48305 6.22807 3.20044 6.43644 2.99206C6.64481 2.78369 6.92743 2.66663 7.22211 2.66663H9.44434C9.73902 2.66663 10.0216 2.78369 10.23 2.99206C10.4384 3.20044 10.5554 3.48305 10.5554 3.77774V4.88885M12.2221 4.88885V12.6666C12.2221 12.9613 12.105 13.2439 11.8967 13.4523C11.6883 13.6607 11.4057 13.7777 11.111 13.7777H5.55545C5.26076 13.7777 4.97815 13.6607 4.76977 13.4523C4.5614 13.2439 4.44434 12.9613 4.44434 12.6666V4.88885H12.2221Z",
  stroke: "#04223B",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.22168 7.66663V11",
  stroke: "#04223B",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.44434 7.66663V11",
  stroke: "#04223B",
  strokeLinecap: "round"
}));

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6498_206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref2), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-icon.0888234c.svg";
export { ForwardRef as ReactComponent };